/**
 * Utilitário de persistência das informações do cliente no LocalStorage do navegador.
 * Permite identificar o cliente nas visitas subsequentes sem necessidade de login com senha.
 */

export interface ClienteSalvo {
    telefone: string;
    nome: string;
    clienteId?: string;
    saldoCashback?: number;
    updatedAt: number;
}

const STORAGE_KEY = 'meupapa_cliente_data';

export function obterClienteLocalStorage(): ClienteSalvo | null {
    if (typeof window === 'undefined') return null;
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed.telefone === 'string' && parsed.telefone.trim()) {
            return parsed as ClienteSalvo;
        }
        return null;
    } catch {
        return null;
    }
}

export function salvarClienteLocalStorage(dados: {
    telefone: string;
    nome: string;
    clienteId?: string;
    saldoCashback?: number;
}): void {
    if (typeof window === 'undefined') return;
    try {
        const clienteData: ClienteSalvo = {
            telefone: dados.telefone.trim(),
            nome: dados.nome.trim(),
            clienteId: dados.clienteId,
            saldoCashback: dados.saldoCashback,
            updatedAt: Date.now()
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(clienteData));
    } catch (e) {
        console.warn('[salvarClienteLocalStorage] Falha ao gravar no localStorage:', e);
    }
}

export function limparClienteLocalStorage(): void {
    if (typeof window === 'undefined') return;
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        console.warn('[limparClienteLocalStorage] Falha ao limpar localStorage:', e);
    }
}
